export default "__VITE_ASSET__QXbBa18N__"